// stores/snackbar.js
import { defineStore } from 'pinia'

export const useSnackbarStore = defineStore('snackbar', {
  state: () => ({
    show: false,
    message: '',
    color: 'error',
    timeout: 5000,
    location: 'bottom',
  }),

  actions: {
    /**
     * Resets the snackbar state to its initial values.
     * @returns {void}
     */
    $reset() {
      this.show = false
      this.message = ''
      this.color = 'error'
      this.timeout = 5000
      this.location = 'bottom'
    },
    showError(message, timeout = 5000) {
      this.show = true
      this.message = message
      this.color = 'error'
      this.timeout = timeout
    },

    showSuccess(message, timeout = 3000) {
      this.show = true
      this.message = message
      this.color = 'success'
      this.timeout = timeout
    },

    showInfo(message, timeout = 4000) {
      this.show = true
      this.message = message
      this.color = 'info'
      this.timeout = timeout
    },

    showWarning(message, timeout = 4000) {
      this.show = true
      this.message = message
      this.color = 'warning'
      this.timeout = timeout
    },

    hide() {
      this.show = false
    },
  },
})
